module.exports = __webpack_public_path__ + "img/orange-delete.1b1aa9e8.svg";